import { IconButton, Tooltip } from '@mui/material';
import React from 'react';

import { StyledBox, Box, Typography, iconStyles } from './header-kpi.style';
import { useNavigate } from 'react-router-dom';
import { AuthCompanyContext } from '@homesusa/auth';
import { AppType, KpiType } from '../../enums';
import { useKpiConfig, useKpiData } from '../../hooks';
import { AppContext } from '../../contexts';

export function HeaderKpi(): JSX.Element {
  const { residentialTotal, lotTotal, residentialDetails, lotDetails, totalPhotoRequest } =
    useKpiData();
  const { currentMarket, setCurrentCompany } = React.useContext(AuthCompanyContext);
  const {
    appState: { apps }
  } = React.useContext(AppContext);

  const navigate = useNavigate();
  const kpiConfig = useKpiConfig(currentMarket);

  const kpiValues = {
    [KpiType.Photo]: {
      total: totalPhotoRequest,
      details: `Total: ${totalPhotoRequest}`
    },
    [KpiType.Residential]: {
      total: residentialTotal,
      details: residentialDetails
    },
    [KpiType.Lot]: { total: lotTotal, details: lotDetails }
  };

  const goToRequest = (route: string, kpiType: KpiType): void => {
    setCurrentCompany(null, currentMarket);

    if (kpiType === KpiType.Photo) {
      const url = `${apps[AppType.PhotoService]}/photo-requests`;
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      navigate(`/${route}`);
    }
  };
  return (
    <StyledBox>
      {Object.keys(kpiConfig).map((key) => {
        const kpiType = key as KpiType;
        const { icon: Icon, tooltip, route, isVisible = true } = kpiConfig[kpiType];
        const { total, details } = kpiValues[kpiType];

        if (!isVisible) return null;

        return (
          <Box key={kpiType} onClick={(): void => goToRequest(route, kpiType)}>
            <Tooltip
              title={<span dangerouslySetInnerHTML={{ __html: details }} />}
              componentsProps={{ tooltip: { sx: { maxWidth: '140px' } } }}
            >
              <IconButton aria-label={tooltip} sx={iconStyles[kpiType]}>
                <Icon />
                <Typography variant='body1'>{total}</Typography>
              </IconButton>
            </Tooltip>
          </Box>
        );
      })}
    </StyledBox>
  );
}
